import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ScatterChart, Scatter, XAxis, YAxis, ZAxis, CartesianGrid } from 'recharts';
import { Row, Col, Table } from 'antd';

const data = [
    { name: 'Scope A', value: 25 },
    { name: 'Scope B', value: 30 },
    { name: 'Scope C', value: 20 },
    { name: 'Scope D', value: 20 },
];

const COLORS = ['#f59689', '#85b4f2', '#a5e2a5', '#fcd3a2'];

// 表格的欄位定義
const columns = [
    {
        title: 'Scoping編號',
        dataIndex: 'scopingNum',
        key: 'scopingNum',
    },
    {
        title: 'Scoping名稱',
        dataIndex: 'scopingName',
        key: 'scopingName',
    },
    {
        title: 'Marc欄位1',
        dataIndex: 'marcField1',
        key: 'marcField1',
    },
    {
        title: 'Marc欄位2',
        dataIndex: 'marcField2',
        key: 'marcField2',
    },
    {
        title: 'Marc欄位3',
        dataIndex: 'marcField3',
        key: 'marcField3',
    },
    {
        title: 'Marc欄位4',
        dataIndex: 'marcField4',
        key: 'marcField4',
    },
    ];

    // 表格資料
    const tableData = [
    {
        key: '1',
        scopingNum: '1',
        scopingName: '館藏區',
        marcField1: '852',
        marcField2: '_',
        marcField3: '-',
        marcField4: '-',
    },
    {
        key: '2',
        scopingNum: '2',
        scopingName: '藏書總類',
        marcField1: 'Leader/06',
        marcField2: '_',
        marcField3: '-',
        marcField4: '-',
    },
    {
        key: '3',
        scopingNum: '3',
        scopingName: '出版年',
        marcField1: '008/07',
        marcField2: '_',
        marcField3: '-',
        marcField4: '-',
    },
];


// 散佈圖數據
const scatterData = [
    { x: 200, y: 400 },
    { x: 300, y: 300 },
    { x: 400, y: 500 },
    { x: 500, y: 200 },
    { x: 600, y: 400 },
    { x: 700, y: 300 },
    { x: 800, y: 100 },
    { x: 900, y: 500 },
    { x: 1000, y: 400 },
];

// 定義 rowSelection 來實現勾選功能
const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
    },
    getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled User', // Column configuration not to be checked
        name: record.name,
    }),
};
const CategorizationGroupTWO = () => {
    return (
    <>
        <div style={styles.searchContainer_title}>
            <Row gutter={[16, 16]} align="middle" style={{paddingTop: '10px'}}>
                <Col span={6}>
                    <div style={{ 
                        padding: '10px', 
                        marginLeft: '20px',
                        backgroundColor: '#e6f7ff', 
                        borderRadius: '10px', 
                        fontWeight: 'bold', 
                        color: '#333', 
                        textAlign: 'center',
                        marginRight: '10px' // 加一點右邊距離
                    }}>
                        常用Discovery選項
                    </div>
                </Col>
                <Col span={18}>
                    <div style={{ 
                        padding: '10px', 
                        marginRight: '20px',
                        backgroundColor: '#e6f7ff', 
                        borderRadius: '10px', 
                        fontWeight: 'bold', 
                        color: '#333', 
                        textAlign: 'center',
                        marginLeft: '10px' // 加一點左邊距離
                    }}>
                        館藏地與館藏類型關係圖
                    </div>
                </Col>
            </Row>
        </div>
        <div style={styles.searchContainer}>
        <Row gutter={[16, 16]} align="middle">
            <Col span={6} style={styles.centerContent}>
            <PieChart width={300} height={300}>
                <Pie
                data={data}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
                label={({ percent }) => `${(percent * 100).toFixed(1)}%`}
                >
                {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
                </Pie>
                <Tooltip />
            </PieChart>
            </Col>
            <Col span={18} style={styles.centerContent}>
                <ScatterChart
                        width={600}
                        height={400}
                        margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                    >
                        <CartesianGrid />
                        <XAxis 
                            type="number" 
                            dataKey="x" 
                            name="Number of Books Filtered" 
                            label={{ value: 'Number of Books Filtered Based on MARC21 Fields', position: 'bottom' }} 
                        />
                        <YAxis 
                            type="number" 
                            dataKey="y" 
                            name="Number of Searches" 
                            label={{ value: 'Number of User Searches', angle: -90, position: 'left' }} 
                        />
                        <Tooltip cursor={{ strokeDasharray: '3 3' }} />
                        <Scatter name="User Searches" data={scatterData} fill="#8884d8" />
                </ScatterChart>
            </Col>
        </Row>
        </div>
        <div style={styles.searchContainer}>
            <Row gutter={[16, 16]} align="middle" style={{ height: '400px', width: '100%' }}>
                <Col span={24} style={styles.centerContent}>
                    <Table
                        rowSelection={{
                            type: 'checkbox', // 可以選擇 'radio' 或 'checkbox'
                            ...rowSelection,
                        }}
                        columns={columns}
                        dataSource={tableData}
                        pagination={false}
                        style={{ width: '100%' }}
                    />
                </Col>
            </Row>
        </div>
    </>
    );
};

export default CategorizationGroupTWO;

const styles = {
    searchContainer: {
        margin: '10px',
        justifyContent: 'center',
        alignItems: 'center',
    },
  centerContent: {
    display: 'flex',
    justifyContent: 'center', 
    alignItems: 'center',      
    height: '100%',            
    textAlign: 'center',       
    overflowX: 'auto',
  },
  colorBarContainer: {
    width: '50px', // 色條寬度
    height: '200px', // 色條高度
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #000' // 邊框
  },
  label: {
    color: '#fff',
    fontSize: '12px',
    textAlign: 'center',
    display: 'block',
    padding: '4px'
  }
};
